import { render, staticRenderFns } from "./DetailsLayout.vue?vue&type=template&id=af2a9428&scoped=true"
import script from "./DetailsLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DetailsLayout.vue?vue&type=style&index=0&id=af2a9428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2a9428",
  null
  
)

export default component.exports